import {
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";

/**
 * Maps API paths to local mock JSON files. The matcher is exact-match first,
 * then prefix-match — so /api/content-cm-example/80514 falls back to the
 * /api/content-cm-example entry until the real backend lands.
 */
const MOCK_MAP = new Map<string, string>([
  [
    "/commons/coremedia/v1/navigation/retrieveMenuTree",
    "/assets/mock-api/navigation-coremedia-example.json",
  ],
  [
    "/api/content-cm-example",
    "/assets/mock-api/content-coremedia-example.json",
  ],
]);

function resolveMockFile(url: string): string | undefined {
  const path = url.split("?")[0];
  const exact = MOCK_MAP.get(path);
  if (exact) {
    return exact;
  }
  for (const [key, file] of MOCK_MAP) {
    if (path.startsWith(`${key}/`)) {
      return file;
    }
  }
  return undefined;
}

export function mockApiInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const mockFile = resolveMockFile(req.url);

  if (req.method !== "GET" || !mockFile) {
    return next(req);
  }

  return from(
    fetch(mockFile).then(async (res) => {
      if (!res.ok) {
        throw new Error(`Mock file not found: ${mockFile}`);
      }
      return res.json() as Promise<unknown>;
    }),
  ).pipe(map((body) => new HttpResponse({ status: 200, body })));
}
